import { gql } from '@apollo/client';

export const DELETE_PORTFOLIO = gql`
  mutation DeletePortfolio($id: ID!) {
    template: deletePortfolio(id: $id) {
      id
      name
    }
  }
`;
